import { useEffect, useState } from 'react';
import { fetchAuthenticatedBlob } from '../../api/client';
import styles from './AuthenticatedVideo.module.scss';

type AuthenticatedVideoProps = {
  readonly path: string;
  readonly token: string;
  readonly errorLabel?: string;
  readonly fullscreen?: boolean;
  readonly autoPlay?: boolean;
};

export function AuthenticatedVideo({
  path,
  token,
  errorLabel,
  fullscreen = false,
  autoPlay = false,
}: AuthenticatedVideoProps) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!token) return;
    let objUrl: string | null = null;
    let cancelled = false;

    setIsLoading(true);
    setHasError(false);

    fetchAuthenticatedBlob(path, token)
      .then((blob) => {
        if (cancelled) return;
        objUrl = URL.createObjectURL(blob);
        setBlobUrl(objUrl);
      })
      .catch(() => {
        if (!cancelled) setHasError(true);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
      if (objUrl) URL.revokeObjectURL(objUrl);
    };
  }, [path, token]);

  if (isLoading) return <div className={styles.videoSkeleton} />;
  if (hasError || !blobUrl) {
    return <div className={styles.videoError}>{errorLabel ?? 'Не вдалося завантажити відео'}</div>;
  }

  return (
    <div className={fullscreen ? styles.videoFrameFullscreen : styles.videoFrame}>
      <video
        className={fullscreen ? styles.videoPlayerFullscreen : styles.videoPlayer}
        src={blobUrl}
        controls
        playsInline
        autoPlay={autoPlay}
      />
    </div>
  );
}
